import { jsx as a, jsxs as d, Fragment as l } from "react/jsx-runtime";
import { f as h, w as g } from "../../vendor--aJiswR_.js";
import { forwardRef as p } from "react";
import { stupidInvertClasses as u } from "../../utils/index.js";
import { getButtonStyles as y } from "../BaseButton/index.js";
import { BaseIcon as B } from "../BaseIcon/index.js";
import { isIconName as k } from "../BaseIcon/typeGuards.js";
import { withTooltip as b } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as z } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index12.css';const x = "_secondary_fikzh_1", I = "_heart_fikzh_2", $ = "_pin_fikzh_3", L = "_star_fikzh_4", T = "_sm_fikzh_41", w = "_hasLabel_fikzh_41", j = "_md_fikzh_45", v = "_toggleButton_fikzh_49", t = {
  secondary: x,
  heart: I,
  pin: $,
  star: L,
  sm: T,
  hasLabel: w,
  md: j,
  toggleButton: v
};
function N({ size: s = "md", variant: o = "secondary", __inverted: c, children: e, icon: m, ...n }, i) {
  const f = h(
    y({
      size: s,
      variant: o === "secondary" ? "secondary" : "ghost",
      ...n
    }),
    t.toggleButton,
    e ? t.hasLabel : void 0,
    t[o],
    t[s],
    c ? u() : void 0
  );
  return /* @__PURE__ */ a(
    g,
    {
      ...z(n),
      className: f,
      ref: i,
      "data-component": "ToggleButton",
      children: ({ isSelected: _ }) => {
        const r = o === "secondary" ? m : `${o}${_ ? "-filled" : ""}`;
        return /* @__PURE__ */ d(l, { children: [
          k(r) && /* @__PURE__ */ a(B, { icon: r, size: s }),
          e
        ] });
      }
    }
  );
}
const G = b(p(N));
export {
  G as ToggleButton
};
//# sourceMappingURL=index.js.map
